import React from "react";

/**
 * NavigationCard Component
 * Clickable card for navigating to company sub-pages
 * Props:
 * - title: Card title (e.g., "Competencies")
 * - description: Brief description of the section
 * - icon: Optional icon component
 * - onClick: Callback when card is clicked
 */
export default function NavigationCard({
  title,
  description,
  icon,
  onClick,
}) {
  return (
    <div
      className="cd-diagnostic-card cd-nav-card"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      {icon && <div className="cd-nav-card-icon">{icon}</div>}
      <div className="cd-diagnostic-head">
        <div className="cd-diagnostic-title">{title}</div>
      </div>
      <div className="cd-diagnostic-desc">{description}</div>
      <div className="cd-diagnostic-actions">
        <button className="cd-open-btn">
          Manage →
        </button>
      </div>
    </div>
  );
}
